//For tracking if tab is currently visible
export const onVisibilityChange = (visibilityState) => ({ type: 'PAGE_VISIBILITY_STATE_CHANGED',visibilityState})